import { render, staticRenderFns } from "./YKRecord.vue?vue&type=template&id=45159d31&scoped=true&"
import script from "./YKRecord.vue?vue&type=script&lang=js&"
export * from "./YKRecord.vue?vue&type=script&lang=js&"
import style0 from "./YKRecord.vue?vue&type=style&index=0&id=45159d31&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45159d31",
  null
  
)

export default component.exports